/**
 * Keep in sync with:
 * `server/powersync-backend/src/domain/therapistSessionNotes/bll/isManualSessionNoteProcessingFrom.ts`
 */
export const isManualSessionNoteProcessingFrom = (
  from: string | null | undefined,
): boolean =>
  typeof from === 'string' &&
  from.length > 0 &&
  (from === 'manual' || from.startsWith('admin@'));
